import AudienceSection from "../components/sections/AudienceSection";
import ClientTicker from "../components/sections/ClientTicker";
import ContactSplit from "../components/sections/ContactSplit";
import { MaskedLine, MaskedLineInView } from "../components/MaskedLine";

export default function WhoWeWorkWithPage() {
  return (
    <main data-testid="page-who-we-work-with">
      <section className="ground-paper pt-[104px] pb-14 md:pt-[132px] md:pb-20">
        <div className="wrap">
          <div className="flex items-center gap-4 mb-10">
            <span className="series-stamp"><span>Rooms · Cohorts</span></span>
            <span className="stamp-dim">Selected quarterly</span>
          </div>
          <h1 className="h-hero max-w-[1200px]" style={{ fontSize: "clamp(56px, 9vw, 156px)" }}>
            <MaskedLine>Not for</MaskedLine>
            <MaskedLine delay={0.1}>everyone<span className="tension">.</span></MaskedLine>
            <MaskedLine delay={0.2}><span className="claim">Here is who.</span></MaskedLine>
          </h1>
          <p className="aside mt-10 max-w-[640px]">
            The studio works with organisations serious about behaviour change. Selective — not aspirational. Selective — because the work demands depth, not volume.
          </p>
        </div>
      </section>

      <ClientTicker />

      <AudienceSection />

      <section className="ground-lab sec-pad">
        <div className="wrap max-w-[900px]">
          <span className="series-stamp green"><span>Engagement</span></span>
          <h2 className="h-section mt-8">
            <MaskedLineInView>Three engagement models.</MaskedLineInView>
            <MaskedLineInView delay={0.08}><span className="claim">Matched to seriousness.</span></MaskedLineInView>
          </h2>

          <ol className="mt-14 divide-y-[1.5px] divide-[color:var(--ink)] border-y-[1.5px] border-[color:var(--ink)]">
            {[
              {
                n: "01",
                title: "Single program intensives",
                body: "Two-to-four-day intensives for a specific cohort. Best when you have an identified capability gap and a clear group to address it with."
              },
              {
                n: "02",
                title: "Multi-cohort capability builds",
                body: "Layered programs across cohorts — 6 to 12 weeks per group, with measurement at the start, middle and end. The most common engagement for enterprise clients."
              },
              {
                n: "03",
                title: "Embedded capability partnership",
                body: "The studio operates as the dedicated communication and leadership capability partner for the organisation. Annual engagement. Senior team only."
              }
            ].map((m) => (
              <li key={m.n} className="py-10 md:py-14 grid grid-cols-[auto_1fr] gap-6 md:gap-14">
                <span className="stamp" style={{ fontSize: 12 }}>Model {m.n}</span>
                <div>
                  <h3 className="h-tile" style={{ fontSize: "clamp(24px, 2.6vw, 34px)" }}>{m.title}</h3>
                  <p className="font-aside mt-6 text-[19px]" style={{ lineHeight: 1.55 }}>{m.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <ContactSplit />
    </main>
  );
}
